import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styles from './Footer.module.css';

const year = new Date().getFullYear();
const Footer = () => (
  <div className={styles.footer}>
    <Row noGutters className={`${styles.footerRow} text-center`}>
      <Col xs={7} md={6} className='mx-auto'>
        <span>&copy; {year} Concentra Corporation. All Rights Reserved</span>
        <br />
        <br />
        <span>
          For any additional questions, please contact our HR at
          <br />
          <a href='mailto:CHSPayrollTax@concentra.com?subject=Alumni%20Portal'>CHSPayrollTax@concentra.com</a>
        </span>
      </Col>
    </Row>
  </div>
);

export default Footer;
